import { Box, Text } from '@chakra-ui/react';
import cn from 'classnames';
import Link from 'next/link';
import React from 'react';

import Image from '@/app/_components/Image';
import { useRoutesConfig } from '@/hooks/routes-config';
import { useFiltersQuery } from '@/hooks/used-cars/filters-query.hook';
import { assetsUri } from '@/services/api.service';
import { getBrowseItemLink } from '@/services/link.service';
import {
  formatBodyUrlPath,
  formatUrlPath,
} from '@/services/string-format.service';
import {
  BrowseItemTypes,
  BrowseTypes,
  VehicleType,
} from '@/types/used-cars/used-cars.types';

import styles from './browse-item.module.scss';

export const BrandBrowseItem: React.FC<{
  item: BrowseItemTypes;
  name?: BrowseTypes;
  className?: string;
  type?: string;
}> = ({ item, name, className, type }) => {
  const { activeCarType } = useFiltersQuery();
  const imageUri = `${assetsUri}/${item.image}?key=image-82-42`;
  const routes = useRoutesConfig();

  let linkUrl;

  if (type === 'body') {
    linkUrl = `${getBrowseItemLink(name, activeCarType, routes)}${formatBodyUrlPath(
      item.name,
    )}`;
  } else if (type === 'model') {
    linkUrl = `${getBrowseItemLink(
      name,
      activeCarType,
      routes,
    )}/kia/models${formatBodyUrlPath(item.name)}`;
  } else {
    linkUrl =
      item.link ||
      `${getBrowseItemLink(name, activeCarType, routes)}${formatUrlPath(
        item.name,
      )}${activeCarType === VehicleType.Demo ? '?type=demo' : ''}`;
  }

  const toTitleCase = (str: string) => {
    if (
      str !== 'BMW' &&
      str !== 'BAW' &&
      str !== 'CAM' &&
      str !== 'DFM' &&
      str !== 'DFSK' &&
      str !== 'GAZ' &&
      str !== 'GWM' &&
      str !== 'JAC' &&
      str !== 'JMC' &&
      str !== 'MG' &&
      str !== 'FAW' &&
      str !== 'TATA' &&
      str !== 'TVR' &&
      str !== 'UD Trucks' &&
      str !== 'UD TRUCKS'
    ) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    } else {
      return str;
    }
  };

  return item.image ? (
    <Link href={linkUrl} className={styles.itemBrandLink} prefetch={false}>
      <Box
        className={cn(
          styles.itemBrand,
          {
            [styles.itemDisabled as string]: item?.isDisabled,
          },
          className,
        )}
      >
        <Box width={'100%'}>
          <Box className={styles.itemBrandImageWrapper}>
            <Image
              className={styles.image}
              src={imageUri}
              alt={item.fullName || ''}
              title={item.fullName || ''}
              width={82}
              height={42}
            />
          </Box>
          <Text className={styles.text}>{toTitleCase(item.name)}</Text>
        </Box>
      </Box>
    </Link>
  ) : null;
};
